<template>
  <div class="container">
    <div class="box mt-6">
      <div class="columns">
        <div class="column is-6">
          <h1 class="title is-4">{{ $t("configuration file") }}</h1>
        </div>
        <div class="column is-6">
          <p class="buttons is-pulled-right">
            <button
              class="button is-primary is-rounded"
              @click="save"
              v-if="meta"
            >
              <span class="icon">
                <i class="fa fa-save"></i>
              </span>
              <span>{{ $t("save") }}</span>
            </button>
            <button
              class="button is-primary is-rounded"
              @click="init"
              v-if="!meta"
            >
              <span class="icon">
                <i class="fa fa-edit"></i>
              </span>
              <span>{{ $t("edit") }}</span>
            </button>
            <button class="button is-danger is-rounded" @click="reset">
              <span class="icon">
                <i class="fa fa-refresh"></i>
              </span>
              <span>{{ $t("reset") }}</span>
            </button>
          </p>
        </div>
      </div>
      <div class="table-container">
        <form v-if="meta">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("instance name") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.instance_name"
                  />
                </div>
              </div>
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_hide_enterprise"
                  v-model="meta.hide_enterprise_field"
                />
                <label for="chk_hide_enterprise">{{
                  $t("hide enterprise field")
                }}</label>
              </div>
              <div class="field">
                <label class="label">{{ $t("default enterprise") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.default_enterprise"
                  />
                </div>
              </div>
              <div class="field">
                <label class="label">{{ $t("logo") }}</label>
                <div class="control">
                  <input class="input" type="text" v-model="meta.logo" />
                </div>
              </div>
              <div class="field">
                <label class="label">{{ $t("default language") }}</label>
                <div class="control">
                  <div class="select">
                    <select v-model="meta.default_language">
                      <option value="es">{{ $t("spanish") }}</option>
                      <option value="en">{{ $t("english") }}</option>
                      <option value="fr">{{ $t("french") }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("git repository url") }}</label>
                <div class="control">
                  <input class="input" type="text" v-model="meta.git_url" />
                </div>
              </div>
              <div class="field">
                <label class="label">{{ $t("git user") }}</label>
                <div class="control">
                  <input class="input" type="text" v-model="meta.git_user" />
                </div>
              </div>
              <div class="field">
                <label class="label">{{ $t("git password") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="password"
                    v-model="meta.git_password"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("modul repository host") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.modul_repository_host"
                  />
                </div>
              </div>
              <div class="field">
                <label class="label">{{ $t("modul repository user") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.modul_repository_user"
                  />
                </div>
              </div>
              <div class="field">
                <label class="label">{{
                  $t("modul repository password")
                }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="password"
                    v-model="meta.modul_repository_password"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
      </div>
    </div>

    <!-- <pre>{{ meta }}</pre> -->

    <!-- <enterprise-modal ref="enterprise_modal" @success="refresh" /> -->
  </div>
</template>

<script>
// import EnterpriseModal from "./enterprise_modal/Index.vue";

import {
  get,
  post,
  success_message,
  confirm_deletion_dialog,
  generate_error_message_text,
} from "@/utils";

export default {
  name: "SettingsConfig",
  // components: { EnterpriseModal },
  data() {
    return {
      meta: undefined,
      error: "",
    };
  },
  methods: {
    // refresh() {
    //   let v = this;
    //   v.datatables_instance.ajax.reload();
    // },
    init() {
      let v = this;
      v.$root.loader(true);
      get("/system/settings/file", {})
        .then((response) => {
          v.meta = response;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    save() {
      let v = this;
      v.$root.loader(true);
      post("/system/settings/file", v.meta)
        .then((/* response */) => {
          // v.meta = response;
          success_message(v.$t("file saved"));
          v.error = "";
          v.meta = undefined;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    reset() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to restart system?"),
        v,
        () => {
          get("/system/settings/restart", {})
            .then(() => {
              success_message(v.$t("system restarted"));
            })
            .catch((error) => {
              v.error = generate_error_message_text(error);
            });
        }
      );
    },
  },
  mounted() {
    // let v = this;
    // v.init();
  },
};
</script>

<style></style>
